query GetGrantBasketItems(
  $page: Int
  $limit: Int
  $search: String
  $status: GrantBasketItemsSearchEnum!
) {
  grantBasketItems(
    page: $page
    limit: $limit
    search: $search
    status: $status
  ) {
    collection {
      id
      userFirstName
      userSurname
      userId
      charityName
      amount {
        minorUnit
        currency
      }
      status
      lastErrorMessage
      createdDate
      wasProcessedImmediately
      grantCreationMethod
      grantFormSource
      reasonForHifoGrant
      reasonForHifoGrantAdditional
    }
    metadata {
      totalPages
      totalCount
      currentPage
      limitValue
    }
  }
}
